import React from 'react';
import styles from './LinkBar.css.js';
import Radium from 'radium';
import links from './links';

const LinkBar = Radium(({theme}) => {

    const Linkout = Radium(({ text, url }) => (
        <a style={styles.link} href={url} target='_blank' rel='noreferrer'><div style={styles.linkText}>{text}</div></a>
    ));

    const mainStyle = Object.assign({}, styles.main, styles[theme])
    return (
        <div style={mainStyle}>
            <Linkout text='Official Rules |' url={links[theme][0]}/>
            <Linkout text='See Sweepstakes Facts |' url={links[theme][1]}/>
            <Linkout text='Privacy Policy' url='https://privacy.pch.com/'/>
        </div>
    )
});

export default LinkBar;